import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Modal, Input, Select, Textarea, Btn } from "@/components/UI";
import { ADJUST_REASONS, fmtQty } from "@/lib/products";
import { apiError } from "@/lib/customers";

const EMPTY = { mode: "set", value: "", reason: "", description: "" };

export function StockAdjustModal({ row, onClose, onSaved }) {
  const [f, setF] = useState(EMPTY);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (row) { setF(EMPTY); setErr(""); } }, [row]);
  if (!row) return null;
  const set = (k) => (e) => { setErr(""); setF({ ...f, [k]: e.target.value }); };
  const val = Number(f.value);
  const after = f.value === "" || Number.isNaN(val) ? null : (f.mode === "set" ? val : row.on_hand + val);

  const save = async () => {
    if (after === null) return setErr("Miktar giriniz");
    if (!f.reason) return setErr("Sebep seçiniz");
    if (after < 0) return setErr("Stok negatif olamaz");
    setBusy(true);
    try { await api.post("/stock/adjust", { product_id: row.product_id, mode: f.mode, value: val, reason: f.reason, description: f.description }); onSaved(); }
    catch (e) { setErr(apiError(e, "Stok düzeltme başarısız")); }
    finally { setBusy(false); }
  };

  return (
    <Modal open onClose={onClose} title="Stok Düzeltme">
      <div className="space-y-3" data-testid="stock-adjust-form">
        <div className="text-sm"><b>{row.code}</b> — {row.name} · Mevcut: <b data-testid="adj-current">{fmtQty(row.on_hand)}</b></div>
        <div className="grid grid-cols-2 gap-3">
          <Select label="Giriş Türü" value={f.mode} onChange={set("mode")} data-testid="adj-mode">
            <option value="set">Yeni miktar</option>
            <option value="delta">Fark (+/-)</option>
          </Select>
          <Input label={f.mode === "set" ? "Yeni Miktar" : "Fark"} type="number" value={f.value} onChange={set("value")} data-testid="adj-value" />
        </div>
        <Select label="Sebep *" value={f.reason} onChange={set("reason")} data-testid="adj-reason">
          <option value="">Seçiniz…</option>
          {ADJUST_REASONS.map((r) => <option key={r.key} value={r.key}>{r.label}</option>)}
        </Select>
        <Textarea label="Açıklama" value={f.description} onChange={set("description")} data-testid="adj-description" />
        {after !== null && <div className="text-xs text-slate-600" data-testid="adj-preview">Sonuç: {fmtQty(row.on_hand)} → <b>{fmtQty(after)}</b></div>}
        {err && <div className="text-sm text-rose-600 bg-rose-50 border border-rose-200 rounded-md px-3 py-2" data-testid="adj-error">{err}</div>}
      </div>
      <div className="flex justify-end gap-2 mt-4">
        <Btn variant="secondary" onClick={onClose} data-testid="adj-cancel">Vazgeç</Btn>
        <Btn onClick={save} disabled={busy} data-testid="adj-save">{busy ? "Kaydediliyor…" : "Düzeltmeyi Kaydet"}</Btn>
      </div>
    </Modal>
  );
}
